angular.module('filters').filter('stringToDate', function() {
  return function(string, fromFormat, toFormat) {
    fromFormat || (fromFormat = 'YYYY-MM-DD');
    toFormat || (toFormat = 'D MMM YYYY');
    if (string && moment(string, fromFormat, true).isValid()) {
      return moment(string, fromFormat).format(toFormat);
    } else {
      return string;
    }
  };
});
